export const SCRIPT_KEYS = {
  NAVER_MAP: 'naver-map',
  GENTOO: 'gentoo',
} as const;

export type ScriptKey = (typeof SCRIPT_KEYS)[keyof typeof SCRIPT_KEYS];

// 상용은 sdk.gentooai.com, 그 외 (dev/staging/local) 는 dev-sdk 를 사용한다.
// Gentoo 측이 partnerId 별로 endpoint 화이트리스트를 관리하기 때문에
// dev partnerId 는 반드시 dev-sdk 로 로드해야 SDK 가 정상 부팅된다.
export const GENTOO_SDK_SRC =
  process.env.ENVIRONMENT === 'product'
    ? 'https://sdk.gentooai.com/sdk.js'
    : 'https://dev-sdk.gentooai.com/sdk.js';

export function getNaverMapScriptUrl(): string | null {
  const clientId = process.env.NEXT_PUBLIC_NCP_CLIENT_ID;
  if (!clientId) return null;
  return `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${clientId}`;
}
